import React, { useState } from "react";
import Icon from "components/AppIcon";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { createContactUservice } from "redux/services/general_service";

const ContactSection = ({ language }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
   
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const translations = {
    en: {
      title: "Get Started Today",
      subtitle:
        "Contact us to begin your fitness journey or visit our facility",
      formTitle: "Send us a message",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      interest: "I'm interested in",
      message: "Message",
      send: "Send Message",
      sending: "Sending...",
      interests: {
        membership: "Membership Information",
        personal: "Personal Training",
        classes: "Group Classes",
        corporate: "Corporate Programs",
        other: "Other",
      },
      contactInfo: "Contact Information",
      visitUs: "Visit Us",
      address: "Aljamaa Street",
      hours: "Operating Hours",
      schedule: {
        weekdays: "Monday - Friday: 5:00 AM - 11:00 PM",
        saturday: "Saturday: 6:00 AM - 10:00 PM",
        sunday: "Sunday: 7:00 AM - 9:00 PM",
      },
      phone: "phone",
      emailContact: "info@fitprocenter.com",
      social: "Follow Us",
      success: "Message sent successfully! We'll get back to you soon.",
      error: "Failed to send message. Please try again.",
    },
    ar: {
      title: "ابدأ اليوم",
      subtitle: "اتصل بنا لبدء رحلة اللياقة البدنية أو قم بزيارة منشأتنا",
      formTitle: "أرسل لنا رسالة",
      name: "الاسم الكامل",
      email: "عنوان البريد الإلكتروني",
      phone: "رقم الهاتف",
      interest: "أنا مهتم بـ",
      message: "الرسالة",
      send: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      interests: {
        membership: "معلومات العضوية",
        personal: "التدريب الشخصي",
        classes: "الفصول الجماعية",
        corporate: "البرامج المؤسسية",
        other: "أخرى",
      },
      contactInfo: "معلومات الاتصال",
      visitUs: "زرنا",
      address: "حي الجامعة",
      hours: "ساعات العمل",
      schedule: {
        weekdays: "الإثنين - الجمعة: 5:00 ص - 11:00 م",
        saturday: "السبت: 6:00 ص - 10:00 م",
        sunday: "الأحد: 7:00 ص - 9:00 م",
      },
      phone: "رقم الهاتف",
      emailContact: "info@fitprocenter.com",
      social: "تابعنا",
      success: "تم إرسال الرسالة بنجاح! سنعود إليك قريباً.",
      error: "فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى.",
    },
  };

  const t = translations[language];
  const isRTL = language === "ar";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);
    dispatch(createContactUservice(formData))
      .then((response) => {
        if (
          response?.payload?.status === 200 ||
          response?.payload?.status === 201
        ) {
          setIsSubmitting(true);
          toast.success(
            language === "ar"
              ? "  تمت عملية الإضافة بنجاح "
              : "Added successfully !"
          );
          // Simulate form submission
          setTimeout(() => {
            setIsSubmitting(false);
            setSubmitStatus("success");
            setFormData({
              name: "",
              email: "",
              phone: "",

              message: "",
            });

            // Clear success message after 5 seconds
            setTimeout(() => {
              setSubmitStatus(null);
            }, 5000);
          }, 2000);
        } else {
          response?.payload?.errors?.map((error) => toast.warn(error));
        }
      })
      .catch((error) => {
        toast.error("An error occurred");
      })
      .finally(() => {
        setLoading(false); // Stop loading
      });
  };

  return (
    <section
      id="contact"
      className={`py-20 bg-gray-50 ${isRTL ? "rtl" : "ltr"}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              {t.formTitle}
            </h3>

            {submitStatus === "success" && (
              <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-6 flex items-center gap-2">
                <Icon name="CheckCircle" size={20} />
                {t.success}
              </div>
            )}

            {submitStatus === "error" && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6 flex items-center gap-2">
                <Icon name="AlertCircle" size={20} />
                {t.error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    {t.name}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
                    required
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    {t.email}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
                    required
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    {t.phone}
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  {t.message}
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors resize-vertical"
                  // placeholder="Tell us about your fitness goals..."
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-green-600 text-white py-3 px-6 rounded-lg hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors font-semibold disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <Icon name="Loader2" size={20} className="animate-spin" />
                    {t.sending}
                  </>
                ) : (
                  <>
                    <Icon name="Send" size={20} />
                    {t.send}
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {/* Visit Us */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Icon name="MapPin" size={24} className="text-green-600" />
                {t.visitUs}
              </h3>

              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">
                    {t.contactInfo}
                  </h4>
                  <p className="text-gray-600 mb-4">{t.address}</p>

                  <div className="space-y-2">
                    <div className="flex items-center gap-3 text-gray-700">
                      <Icon name="Phone" size={16} className="text-green-600" />
                      <span>{t.phone}</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-700">
                      <Icon name="Mail" size={16} className="text-green-600" />
                      <span>{t.emailContact}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <Icon name="Clock" size={16} className="text-green-600" />
                    {t.hours}
                  </h4>
                  <div className="space-y-1 text-gray-600">
                    <p>{t.schedule.weekdays}</p>
                    <p>{t.schedule.saturday}</p>
                    <p>{t.schedule.sunday}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Placeholder 
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <div className="bg-gray-200 rounded-lg h-64 flex items-center justify-center">
                <div className="text-center text-gray-500">
                  <Icon name="Map" size={48} className="mx-auto mb-2" />
                  <p>Interactive Map</p>
                  <p className="text-sm">Location: 123 Fitness Avenue</p>
                </div>
              </div>
            </div>*/}

            {/* Social Media */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {t.social}
              </h3>
              <div className="flex gap-4">
                {[
                  { name: "Facebook", icon: "Facebook" },
                  { name: "Instagram", icon: "Instagram" },
                  { name: "Twitter", icon: "Twitter" },
                  { name: "YouTube", icon: "Youtube" },
                ].map((social, index) => (
                  <button
                    key={index}
                    className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center hover:bg-green-600 hover:text-white transition-colors"
                  >
                    <Icon name={social.icon} size={20} />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
